import { render, staticRenderFns } from "./javascriptLoader.vue?vue&type=template&id=a2672840"
import script from "./javascriptLoader.vue?vue&type=script&lang=js"
export * from "./javascriptLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports